import ElectricContainer from "./ElectricContainer";

export default ElectricContainer;